import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["microphone-container", { playing: _ctx.ready && !_ctx.microError }]),
    ref: "microPhoneRef"
  }, null, 2))
}